import LoaiTaiLieu from './LoaiTaiLieu.jsx';
import ThamQuyen from './ThamQuyen.jsx';
import HuongDanSuDung from './HuongDanSuDung.jsx';
import OrganizationLevel from './OrganizationLevel.jsx';
import CapDonViHanhChinh from './CapDonViHanhChinh.jsx';
import Position from './Position.jsx';
import QuocTich from './QuocTich.jsx';
import DanToc from './DanToc.jsx';
import Role from './Role.jsx';
import CongChuc from './CongChuc.jsx';
import Administrative from './Administrative.jsx';
import Letters from './Letters.jsx';
import Organization from './Organization.jsx';
import Parameter from './Parameter.jsx';
import CauHinhKHTT from './CauHinhKHTT.jsx';
import Process from './Process.jsx';
import TypeOfOrganizationLevel from './TypeOfOrganizationLevel.jsx';
import LinhVucDoiTuongThanhTra from './LinhVucDoiTuongThanhTra.jsx';
import DoiTuongThanhTra from './DoiTuongThanhTra.jsx';
import NhomDoiTuongThanhTra from './NhomDoiTuongThanhTra.jsx';
import DonViNgoai from './DonViNgoai.jsx';
import CapNhatNguoiDung from './CapNhatNguoiDung.jsx';
import DanhSachDonTheoCongChuc from './DanhSachDonTheoCongChuc.jsx';
import DanhSachDonTheoDonVi from './DanhSachDonTheoDonVi.jsx';
import DanhMucVideo from './DanhMucVideo.jsx';
import Video from './Video.jsx';

export {
  ThamQuyen,
  HuongDanSuDung,
  LoaiTaiLieu,
  Position,
  OrganizationLevel,
  CapDonViHanhChinh,
  DanToc,
  QuocTich,
  Role,
  CongChuc,
  Administrative,
  Letters,
  Organization,
  Parameter,
  CauHinhKHTT,
  Process,
  TypeOfOrganizationLevel,
  LinhVucDoiTuongThanhTra,
  DoiTuongThanhTra,
  NhomDoiTuongThanhTra,
  DonViNgoai,
  DanhMucVideo,
  Video,
  CapNhatNguoiDung,
  DanhSachDonTheoCongChuc,
  DanhSachDonTheoDonVi
};



// WEBPACK FOOTER //
// ./src/components/modules/category/index.js